import React, { useEffect, useRef, useState } from 'react';
import './Experience.css';

const FLYER_IMG = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/w78zbdrz_IMG_0069.jpeg';

const stats = [
  { number: '$50', label: 'pesos', desc: 'Precio único' },
  { number: '100%', label: 'artesanal', desc: 'Pan horneado' },
  { number: 'Premium', label: 'pavo', desc: 'Salchicha' },
];

export const Experience = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="experience" id="experiencia" ref={ref} data-testid="experience-section">
      <div className="experience-fire-accent" />
      <div className="experience-container">
        <div className={`experience-image ${visible ? 'vis' : ''}`}>
          <div className="experience-image-frame">
            <img src={FLYER_IMG} alt="Dogos El Tío Chepe flyer" data-testid="experience-flyer-img" />
          </div>
          <div className="experience-image-glow" />
        </div>
        <div className={`experience-text ${visible ? 'vis' : ''}`}>
          <div className="section-fire-line" />
          <span className="experience-eyebrow">Nuestra Historia</span>
          <h2 className="experience-title">
            Tradición que<br />
            se <em>saborea</em>
          </h2>
          <p className="experience-desc">
            En el corazón de Tapalpa, frente a los Jaimes, nació Dogos El Tío Chepe con una 
            misión: traer el auténtico sabor del dogo sonorense a este pueblo mágico. 
            Cada ingrediente es seleccionado con cuidado — desde nuestro pan artesanal con 
            ajonjolí hasta las salchichas premium de pavo.
          </p>
          <p className="experience-desc">
            Las papas gajo y los aros de cebolla se preparan en air fryer para lograr 
            la textura perfecta. Acompáñalos con una cervecita fría o un refresco 
            mientras disfrutas del ambiente acogedor de nuestro local.
          </p>
          <div className="experience-stats" data-testid="experience-stats">
            {stats.map((s, i) => (
              <div className="experience-stat" key={i}>
                <span className="experience-stat-num">{s.number}</span>
                <span className="experience-stat-label">{s.label}</span>
                <span className="experience-stat-desc">{s.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
